import React, {Suspense, useEffect} from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { CContainer, CSpinner } from '@coreui/react'

// routes config
import routes from '../routes'
import { useSelector } from 'react-redux'

const AppContent = () => {

  const myInfo = useSelector((state) => state.AuthSlice.myInfo)
  return (
    <CContainer fluid>
      <Suspense fallback={<CSpinner color="primary" />}>
        <Routes>
          {routes.map((route, idx) => {
            let mnemo = myInfo?.data?.value?.formViews?.find(el => el.mnemo === route.mnemo)
            if (!mnemo && myInfo) {
              for (let index = 0; index < myInfo?.data?.value?.formViews.length; index++) {
                mnemo = myInfo?.data?.value?.formViews[index].children.find(el => el.mnemo === route.mnemo);
                if (mnemo) break
              }
            }
            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={<route.element mnemo={mnemo} />}
                />
              )
            )
          })}
          <Route path="/" element={<Navigate to="clients" replace />} />
        </Routes>
      </Suspense>
    </CContainer>
  )
}

export default React.memo(AppContent)
